import { Fragment } from "react";
import IconTileBreakup from "../IconTileBreakup";

export const TileBreakup = () => {
  return (
    <Fragment>
      <div className="hidden md:block h-30 md:h-[10vw] relative w-full overflow-hidden mt-[-120px]">
        <IconTileBreakup
          data-fill-color="#FFF"
          className="absolute left-[-100vw] right-[-100vw] bottom-[-1px] w-[300vw] md:left-0 md:right-0 md:w-full h-auto text-gray-100"
        />
      </div>
      <div className="flex md:hidden relative w-full mt-[-80px]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="360"
          height="35"
          viewBox="0 0 360 35"
          fill="none"
          className="w-full"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-222 0.302527H-87.8333L-87.8337 11.605H46.333V0.302444L-87.8333 0.302527V-11H-222V0.302527ZM582 0.302527H447.833V-11H582V0.302527ZM447.833 0.302527L447.833 11.605H313.667V0.302444L447.833 0.302527ZM180.5 22.9079H313.667V11.6054H180.5H179.5H46.3331V22.9079H179.5H180.5ZM582 40.921H447.833V35.0002H314V23.0002H447.833V14.4307H582V40.921ZM-87.8333 40.921H-222V14.4307H-87.8333V23.0002H45.9999V35.0002H-87.8333V40.921Z"
            fill="white"
          />
        </svg>
      </div>
    </Fragment>
  );
};
